module.exports = __webpack_public_path__ + "static/media/YF103_3.300b326b.jpg";